export default "__VITE_ASSET__ClmocHos__"